import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { Grid, Typography } from "@mui/material";
import { useMemo } from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import type { SelectedCompanyReport } from "../hooks/SelectedCompany";
import { getInvalidFieldsCount } from "../utils/getInvalidFieldsCount";

interface Props {
  companyReport: SelectedCompanyReport;
}
const Validated = ({ companyReport }: Props) => {
  const invalidFieldsCount = useMemo(() => getInvalidFieldsCount(companyReport.result), [companyReport.result]);

  const selectedGroupName = useMemo(
    () => companyReport.selectedGroup?.caption || companyReport.result?.group?.name,
    [companyReport.result?.group?.name, companyReport.selectedGroup?.caption]
  );

  const isNewGroup = useMemo(
    () => companyReport.result?.group?.exist === false && selectedGroupName === companyReport.result?.group?.name,
    [companyReport.result?.group?.exist, companyReport.result?.group?.name, selectedGroupName]
  );

  return (
    <Grid container sx={{ gap: 0.8, flexWrap: "nowrap", alignItems: "center", width: "100%" }}>
      <Typography variant="subtitle2" sx={{}}>
        To Group:
      </Typography>
      {isNewGroup && (
        <Typography color="secondary" sx={{ mr: -0.2 }}>
          A new group will be added
        </Typography>
      )}
      <Typography sx={{}}>{selectedGroupName}</Typography>
      <HorizontalFill />
      {invalidFieldsCount === 0 && (
        <>
          <Typography sx={{ color: "success.main" }}>All fields will be copied</Typography>
          <CheckRoundedIcon color="success" />
        </>
      )}
      {invalidFieldsCount > 0 && (
        <>
          <Typography sx={{ color: "warning.main" }}>
            {`${invalidFieldsCount} field${invalidFieldsCount > 1 ? "s" : ""} can't be copied`}
          </Typography>
          <WarningRoundedIcon color="warning" />
        </>
      )}
    </Grid>
  );
};

export default Validated;
